import { useQuery } from "@tanstack/react-query";
import {
  mvpApiListJobTasks,
  type JobTaskListSchema,
} from "@augmodo/lebron-browser-client";

export function useFetchJobTasks(jobId?: string) {
  return useQuery({
    queryKey: ["job-tasks", jobId],
    queryFn: async () => {
      const response = await mvpApiListJobTasks({
        path: {
          job_id: jobId || "",
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch job tasks: ${response.error}`);
      }

      return response.data as JobTaskListSchema;
    },
    enabled: !!jobId,
    staleTime: 10 * 1000, // 10 seconds - data is stale after 10s
    gcTime: 5 * 60 * 1000, // 5 minutes - cache garbage collected after 5min
  });
}
